<script setup lang="ts">
import clsx from 'clsx'

import IconDesktop from '@/components/atoms/icons/IconDesktop.vue'
import IconMobile from '@/components/atoms/icons/IconMobile.vue'
import IconTablet from '@/components/atoms/icons/IconTablet.vue'
import type { BetaEditorPreviewDevice } from '@/utils/editor-beta-preview'

const props = withDefaults(defineProps<{
    modelValue?: BetaEditorPreviewDevice
}>(), {
    modelValue: 'desktop',
})

const emit = defineEmits<{
    (event: 'update:modelValue', value: BetaEditorPreviewDevice): void
}>()

const options = [
    { value: 'desktop' as const, label: 'Desktop', icon: IconDesktop },
    { value: 'tablet' as const, label: 'Tablet', icon: IconTablet },
    { value: 'mobile' as const, label: 'Mobile', icon: IconMobile },
]
</script>

<template>
    <div class="beta-editor-viewport-toggle" role="group" aria-label="Alternar visualizacao">
        <button
            v-for="option in options"
            :key="option.value"
            type="button"
            :aria-pressed="props.modelValue === option.value"
            :class="clsx('beta-editor-viewport-toggle__button', props.modelValue === option.value && 'is-active')"
            @click="emit('update:modelValue', option.value)"
        >
            <span class="sr-only">{{ option.label }}</span>
            <component :is="option.icon" class="beta-editor-viewport-toggle__icon" />
        </button>
    </div>
</template>

<style scoped>
.beta-editor-viewport-toggle {
    @apply inline-flex items-center gap-1 rounded-2xl border border-[#E4E8F1] bg-white p-1 shadow-[0_8px_24px_rgba(15,23,42,0.06)];
}

.beta-editor-viewport-toggle__button {
    @apply flex h-10 w-10 items-center justify-center rounded-xl text-[#7B8BA3] transition-all duration-200 hover:bg-[#F6F8FC];
}

.beta-editor-viewport-toggle__button.is-active {
    @apply bg-[#F2F5FB] text-[#1C2D48] shadow-[inset_0_0_0_1px_rgba(219,227,239,0.9)];
}

.beta-editor-viewport-toggle__icon {
    @apply h-5 w-5;
}
</style>
